import { UserId } from '@cibo/core'
import { useOrgUser } from '@cibo/profile'
import { FilterChip } from '@cibo/ui'
import { ChipProps } from '@mui/material'

type OwnerChipProps = ChipProps & {
  userId: UserId
}

export const OwnerChip = ({ userId, ...chipProps }: Omit<OwnerChipProps, 'label'>) => {
  const user = useOrgUser(userId)

  if (!user.data) return null

  return <FilterChip label={user.data.displayNameFull} {...chipProps} />
}
